import {
    ADD_LOCATION_OPEN,
    ADD_LOCATION_PREPARE_REQUEST,
    ADD_LOCATION_PREPARE_RECEIVE,
    ADD_LOCATION_SAVE_REQUEST,
    ADD_LOCATION_SAVE_RECEIVE,
    ADD_LOCATION_SAVE_RECEIVE_ERROR,
    ADD_LOCATION_CANCEL,
    ADD_LOCATION_CHANGE_VALUE
} from "../config/actions";

let defaultState = {
    addLocationDialogOpen: false,
    loading: false,
    name: '',
    groupName: '',
    workType: null,
    availableWorkTypes: [],
    availableLocationGroups: [],
    errors: []
};

const addShiftReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ADD_LOCATION_OPEN:
            return Object.assign({}, state, {
                addLocationDialogOpen: true,
                name: '',
                groupName: '',
                workType: null,
                availableWorkTypes: [],
                availableLocationGroups: [],
                errors: []
            });
        case ADD_LOCATION_PREPARE_REQUEST:
        case ADD_LOCATION_SAVE_REQUEST:
            return Object.assign({}, state, {
                loading: true
            });
        case ADD_LOCATION_PREPARE_RECEIVE:
            return Object.assign({}, state, {
                availableWorkTypes: action.data.workTypes,
                availableLocationGroups: action.data.locationGroups,
                loading: false
            });
        case ADD_LOCATION_SAVE_RECEIVE:
            return Object.assign({}, state, {
                addLocationDialogOpen: false,
                name: '',
                groupName: '',
                workType: null,
                availableWorkTypes: [],
                availableLocationGroups: [],
                errors: []
            });
        case ADD_LOCATION_SAVE_RECEIVE_ERROR:
            console.log('receiving errors');
            return Object.assign({}, state, {
                errors: action.data.errors,
                loading: false
            });
        case ADD_LOCATION_CANCEL:
            return Object.assign({}, state, {
                addLocationDialogOpen: false,
                name: '',
                groupName: '',
                workType: null,
                availableWorkTypes: [],
                availableLocationGroups: [],
                errors: []
            });
        case ADD_LOCATION_CHANGE_VALUE:
            return Object.assign({}, state, {
                [action.name]: action.value
            });
        default:
            return state;
    }
};

export default addShiftReducer;